import { createPortal } from "react-dom";
import { SITE, origin } from "../lib/util";

export const LdScript = ({ obj }) => createPortal(
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(obj).replace(/<\//g, "<\\/") }} />,
  document.head
);

export const DEFAULT_OG = () => `${origin()}/og-default.jpg`;

export function Head({ title, desc, path, brand = true, noindex = false, ogType = "website", image, ld = [] }) {
  const ttl = brand ? `${title} | ${SITE}` : title;
  const img = image || DEFAULT_OG();
  return (
    <>
      <title>{ttl}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex" />}
      {path !== undefined && <link rel="canonical" href={`${origin()}/${path}`} />}
      {path !== undefined && <meta property="og:url" content={`${origin()}/${path}`} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      {ld.map((x, i) => <LdScript key={i} obj={x} />)}
    </>
  );
}
